// extracted by mini-css-extract-plugin
export default {"color-disabled":"app_color-disabled__J-DD9"};